import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  inject,
} from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { PayeeHeaderComponent } from '../../../shared/payee-header/payee-header.component';
import { NgTemplateOutlet } from '@angular/common';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header-app',
  templateUrl: './header-app.component.html',
  styleUrls: ['./header-app.component.scss'],
  imports: [
    PayeeHeaderComponent,
    NgTemplateOutlet,
    PayeeIconButtonComponent,
    PayeeIconComponent,
    RouterLink,
  ],
})
export class HeaderAppComponent {
  private authService = inject(AuthService);

  @Input() set xClicked(fn: () => void) {
    this.onXClicked = fn;
  }
  @Input({ required: true }) xLink!: string;
  @Input() payeeLink = 'https://payee.tech';

  @ContentChild('logoTemplate') logoTemplateRef!: TemplateRef<unknown>;

  onXClicked = () => {};

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
